import styled from 'styled-components'

const HeaderStyle = styled.header`
  grid-area: header;
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto auto;
  h1 {
    color: ${props => props.theme.black87};
    font-size: 36px;
    letter-spacing: 0.3px;
    margin: 0;
    font-weight: 300;
    max-width: 830px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  h4 {
    margin: 0 0 8px 0;
    color: ${props => props.theme.black60};
  }
  div {
    display: flex;
    align-items: flex-end;
  }

  .buttons {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-column-gap: 8px;
  }

  .spanTwoColumns {
    grid-column: 2/4;
  }

  .spanThreeColumns {
    grid-column: 1/4;
  }

  .moreButton {
    min-width: 36px;
    padding: 6px 5px 8px;
  }

  @media print {
    .buttons {
      display: none;
    }
  }
`
export default HeaderStyle
